<template>
    <div class="full-page about-page">
        <div class="content">
           <p>佳优生活家作为浙江智想大成物业服务集团专为业主研发的一款集“物业管理、智慧社区、智能家居、家庭服务”于一体的移动端APP。以维护业主权益、服务业主为使命，立志在所有服务的社区通过软硬件结合优质的物业服务，为业主打造成“与智慧社区生活0距离”的一站式服务平台。让我们的社区生活变得更加的智能安全、简单方便。</p>
           <p>通过它，可以实现物业基础服务的移动在线管理如：手机开门，在线缴纳物业费、投诉报修建设等功能。</p>
        </div>
        <div class="copyright">
            <div>ICP备案号:浙ICP备2020032849号-3A</div>
            <div>Copyright©2020</div>
            <div>浙江智想大成物业服务集团 版权所有</div>
        </div>
    </div>
</template>
<script>
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
export default {
    mounted() {
        BridgeNativeMethods.setTitle("");
    }
}
</script>
<style lang="less" scoped>
    .about-page{
        position: relative;
        background: url('~@/assets/images/about_bg.jpg')  center top/cover no-repeat;
    }
    .content{
        text-indent: 2em;
        font-size: 14px;
        color: #fff;
        padding-top: 180px;
        padding-left: 30px;
        padding-right: 30px;
    }
    .copyright {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 50px;
        color: #fff;
        font-size: 12px;
        text-align: center;
    }
</style>